import React from 'react';
import { SvgIcon } from "../svg-icon";

import {
  IDropdownMenu,
  IDropdownGeneric
} from './types';

import {
  Title,
  StyledMenu,
  StyledDropdown,
  StyledMenuItem,
  SelectedOption,
  DropdownContainer,
  PurityDropdownContainer,
  PurityDropdownItem,
  Image
} from './Dropdown-styled';


const menu = ({
  options,
  onChange,
  defaultOption,
}: IDropdownMenu) => (
  <StyledMenu
    onClick={({ key }) => {onChange(key)}}
  >
    { options.map((option: any) =>
      <StyledMenuItem
        key={option.value}
        isSelected={option === defaultOption}
        onClick={(e) => e.domEvent.stopPropagation()}
      >
        {option.image && <Image src={option.image}></Image>}
        {option.label}
      </StyledMenuItem>
    )}
  </StyledMenu>
);

export const Dropdown = ({
  width,
  title,
  opacity,
  options,
  onChange,
  highlight,
  defaultOption,
  titleFontWeight,
  defaultImage,
  disabled = false,
}: IDropdownGeneric): JSX.Element => (
  <DropdownContainer className="threed-configurator-dropdown-container"
    width={width}
    opacity={opacity}
    isDisabled={disabled}
  >
    {title.length >0 && <Title className="threed-configurator-dropdown-title"
      title={title}
      highlight={highlight}
      titleFontWeight={titleFontWeight}
    >
      {title}
    </Title>}
    <StyledDropdown className="threed-configurator-dropdown"
      overlay={
        menu({
          options,
          onChange,
          defaultOption,
        })
      }
      trigger={['click']}
      disabled={disabled}
      placement={'bottomLeft'}
    >
      <SelectedOption className="threed-configurator-dropdown-selected-option">        
        {defaultImage && <Image src={defaultImage}></Image>}
        <span>{defaultOption}</span>
        <SvgIcon className="threed-configurator-svg-icon"
          type="arrowLeft"
        />
      </SelectedOption>
    </StyledDropdown>
  </DropdownContainer>
);

interface IPurityDropdownProps extends IDropdownMenu {
  disabled?:boolean
}

export const PurityDropdown:React.FunctionComponent<IPurityDropdownProps> = (props) => {
  const { defaultOption, options, onChange, disabled } = props;

  return (
    <PurityDropdownContainer className="threed-configurator-purity-dropdown-container">
      {
        options.map((t,index)=> <PurityDropdownItem 
          onClick={()=>onChange(t)} 
          key={index}
          isLastItem={index == options.length - 1}
          isCheck={t === defaultOption}
        >{t}</PurityDropdownItem>)
      }     
    </PurityDropdownContainer>
  )
};